export default __webpack_public_path__ + "static/media/ShantyTownMap.96ae5643.jpg";